import Progress from 'redux-progress';

import { FETCH_CONSENT_HUB_LINK } from '../actions/consentHub';
import { MACConsentHubAction, MACConsentHubState } from '../models/consentHub';

export const initialState: MACConsentHubState = {
  consentHubLink: Progress.none,
};

export default (
  state: MACConsentHubState = initialState,
  action: MACConsentHubAction,
): MACConsentHubState => {
  switch (action.type) {
    case FETCH_CONSENT_HUB_LINK:
      return {
        ...state,
        consentHubLink: action.progress,
      };
    default:
      return state;
  }
};
